import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=54919443&scoped=true"
import script from "./BrandsView.vue?vue&type=script&lang=js"
export * from "./BrandsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54919443",
  null
  
)

export default component.exports